import React, {useCallback} from 'react';
import {Button, Modal} from 'antd';
import {useResourceContext} from "../domain/common/resource/useResourceContext";

export function ScootRebootModal({modalState, setModalState, rebootAction}) {
  const {R} = useResourceContext()

  const hideModal = useCallback(() => {
    setModalState({isVisible: false, isVerify: false});
  }, []);


  const handleClickApply = async () => {
    rebootAction("reboot")
    hideModal()
  }

  const ModalFooter = () => {
    return <>
      <Button type='default' onClick={hideModal}>{R.text.cancel}</Button>
      <Button onClick={handleClickApply} type='primary'
              danger>{R.text.reboot}</Button>
    </>
  }

  return (
    <Modal title={`IoT ${R.text.reboot}`}
           onCancel={() => setModalState({
             isVisible: false, isVerify: false
           })}
           visible={modalState.isVisible}
           footer={<ModalFooter/>}
           forceRender={true}>
      <p>
        {R.text.rebooting_puts_a_load_on_the_server}
      </p>
    </Modal>
  )
}
